import React from "react"
import { useSelector } from "react-redux"
import { PATIENTINFO, REGISTER, SCHEDULE } from "../../utils/constants"
import CommonUsers from "./CommonUsers"
import "./index.css"
import UserRegistrationContainer from "./UserRegistrationContainer"
import Schedule from "../Schedule"

function Registration() {
  // const activeTab = useSelector((state) => state.app.activeTab)

  // function renderActiveTab() {
  //   switch (activeTab) {
  //     case REGISTER:
  //       return <NewUserForm />;
  //     case PATIENTINFO:
  //       return <CommonUsers />;
  //     case SCHEDULE:
  //       return <Schedule />;
  //   }
  // }

  return <UserRegistrationContainer />

  // return (
  //   <div
  //     className="registration-container"
  //   >

  //     <div
  //       className="registration-content"
  //     >
  //       {/* {renderActiveTab()} */}
  //     </div>
  //   </div>
  // );
}

export default Registration
